import { pxToRem } from "@/util/common";
import { CenterPopup, Toast } from "antd-mobile";
import { createUseStyles } from "react-jss";
import { Image, Button } from "antd-mobile";
import useCustomTranslation from "@/hooks/useTranslation";
import { showGlobalLoading } from "@/components/globalLoading";
import { useDispatch } from "react-redux";
import { AppDispatch } from "@/redux/store";
import API from "@/api";
import {
	getUserInfoMethod,
	postApiFinanceBalance,
} from "@/redux/reducers/authSlice";
import useRouter from "@/hooks/useRouter";

const IncomePopup: React.FC<{
	income: number;
	visible: boolean;
	onClose: () => void;
}> = ({ visible, onClose, income }) => {
	const classes = useStyles();
	const dispatch: AppDispatch = useDispatch();
	const { customNavigate } = useRouter();
	const { t } = useCustomTranslation();
	const { showLoading, hideLoading } = showGlobalLoading();
	// 领取收益
	const handleCollect = async () => {
		try {
			showLoading();
			const result: any =
				await API.finances.apiFinanceAgentCommissionReceive();
			if (result?.code === 0) {
				Toast.show({
					content: t("CollectSuccess"),
					position: "top",
				});
				onClose();
				await dispatch(getUserInfoMethod());
				await dispatch(postApiFinanceBalance({}));
				customNavigate("/cashbackRecord");
			}
		} catch (error) {
			Toast.show({
				content: t("CollectFailed"),
				position: "top",
			});
			console.log("领取收益失败:", error);
		} finally {
			hideLoading();
		}
	};

	return (
		<CenterPopup
			bodyStyle={{
				width: "90vw",
			}}
			visible={visible}
			closeOnMaskClick
			destroyOnClose
			onClose={onClose}
			bodyClassName={classes.popupContent}
			maskStyle={{ backgroundColor: "rgba(0, 0, 0, 0.75)" }}
			style={{
				"--max-width": "100vw",
			}}
		>
			<div className={classes.incomeWrap}>
				<h2>{t("Collect")}</h2>
				<div className={classes.incomeContent}>
					<Image
						src={require("@/assets/images/icons/USDT.png")}
						width={24}
						height={24}
					/>
					<span>{income} USDT</span>
				</div>
				<Button
					className={`${classes.btn}`}
					shape="rounded"
					onClick={handleCollect}
				>
					{t("Receive")}
				</Button>
			</div>
		</CenterPopup>
	);
};

export default IncomePopup;

const useStyles = createUseStyles({
	popupContent: {
		color: "#fff",
		textAlign: "center",
		padding: {
			bottom: pxToRem(10),
		},
		backgroundColor: "transparent",
		border: "1px solid #353F63",
		background: "linear-gradient(156deg, #181B24 5.2%, #232C48 97.46%)",
	},
	incomeWrap: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		position: "relative",
		height: pxToRem(220),
		borderBottomLeftRadius: pxToRem(20),
		borderBottomRightRadius: pxToRem(20),
		marginBottom: pxToRem(18),
		backgroundRepeat: "no-repeat",
		backgroundSize: "100% 100%",
		"& h2": {
			color: "#FFFFFF",
			textAlign: "center",
			marginTop: pxToRem(22),
			fontFamily: "Poppins",
			fontWeight: 600,
			fontSize: pxToRem(18),
			letterSpacing: 0,
		},
	},
	incomeContent: {
		display: "flex",
		flex: 1,
		alignItems: "center",
		justifyContent: "center",
		gap: pxToRem(10),
		"& span": {
			fontFamily: "Poppins",
			fontWeight: 400,
			fontSize: pxToRem(16),
			letterSpacing: 0,
			textAlign: "center",
		},
	},
	btn: {
		width: pxToRem(252),
		height: pxToRem(50),
		margin: "0 auto",
		boxShadow: `inset 0 ${pxToRem(2)} ${pxToRem(
			4
		)} rgba(0,194,255, 0.25), 0 ${pxToRem(10)} ${pxToRem(
			10
		)} rgba(24,77,237, 0.3)`,
		"--border-width": 0,
		"--text-color": "#FFFFFF",
		background: "linear-gradient(to right,#4675FF, #0E329D)",
	},
});
